(function () {
    'use strict';

    angular
        .module('core.filters')
        .filter('accessLevelUnit', AccessLevelUnitFilter)

    function AccessLevelUnitFilter() {
        return (accessLevel, personUnit) => {
            if(!accessLevel)
                return;

            console.log('accessLevel: ', accessLevel);
            if(!personUnit || !personUnit.Unit || !personUnit.Unit.HeadUnitId)
                return accessLevel.filter(x => x.Id != 3 && x.Id != 4);

            return accessLevel.filter(x => x.Id == 3);
        }
    }
}());